const formatDecimal = (value?: number | string | null, digits = 2) => {
  if (value == null) return '-';

  if (typeof value === 'string') return value;

  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export default formatDecimal;
